import { OrganizationSettings } from '@care-portals/api-interfaces';
import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { ADMIN_WEB_PAGES_URLS } from '../../EMR_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../../PATIENT_WEB_PAGES_URLS';
import { usStates } from '../../data';

const states = usStates;

// .filter(
//   s => !['FL', 'GA', 'AZ', 'OH', 'WA', 'VA', 'CA', 'NY'].includes(s.code)
// );

export const momwell: OrganizationSettings = {
  name: 'Momwell',
  fromEmail: 'hello@momwell.com',
  replyToEmail: 'hello@momwell.com',
  forgotPasswordTemplateId: '6491bfd244a33598f94214ea',
  verifyAccountTemplateId: '6484b3fab8820c08aa9d8df2',
  ecommerceEnabled: true,
  stripeEnabled: true,
  conversationServiceId: 'IS9d8b15500b914f3a98bff0a083e18592',
  patientPortalDomain: 'momwell.portals.care',
  currency: 'usd',
  crmWebAppLayout: {
    title: 'Momwell US Archive',
    icon: 'https://uploads-ssl.webflow.com/630cf5c3fde88d3fa5008ecc/64e7b973bdcebab0ff0d4f17_icon-momwell.svg?ssl=1',
    locations: states.map(s => ({ value: s.code, label: s.province })),
    mainMenu: [
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Store Manager',
        link: '',
        icon: 'fas fa-shop',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Products',
            link: CRM_WEB_PAGES_URLS.products.list,
            icon: 'fas fa-product'
          },
          {
            title: 'Coupons',
            link: CRM_WEB_PAGES_URLS.coupons.list,
            icon: 'fas fa-gift'
          },
          {
            title: 'Promotions',
            link: CRM_WEB_PAGES_URLS.promotions.list,
            icon: 'fas fa-gift'
          }
        ]
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  },
  emrWebAppLayout: {
    title: 'Momwell US Archive',
    defaultPingMsg:
      '🛎️ Ping! Momwell care team is waiting for your response. To respond, please go to https://momwell.portals.care/messages',
    mainMenu: [
      {
        title: 'Patients',
        name: 'patients',
        link: ADMIN_WEB_PAGES_URLS.customers.allList,
        icon: 'fas fa-user-injured',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: ADMIN_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fas fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Purchases',
        name: 'purchases',
        link: ADMIN_WEB_PAGES_URLS.orders.allList,
        icon: 'fas fa-shopping-cart',
        roles: ['admin', 'owner', 'user']
      }
    ],
    customerTabs: [
      'consults',
      'appointments',
      'invoices',
      'notes',
      'files',
      'payment-methods'
    ],
    questionnaires: [
      'epds',
      'phq9',
      'gad7',
      'dass21',
      'pcl5',
      'bms_before',
      'bms_after',
      'momwell_history_form',
      'momwell_partner_history_form'
    ]
  },
  patientWebAppLayout: {
    title: 'Momwell',
    brand: 'momwell',
    shopUrl: 'https://www.momwell.com/shop',
    topAction: {
      title: 'Book Now',
      link: 'https://momwell.com/booking?email=${email}'
    },
    logo: {
      img: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/64818f81ebfcd0967261457e_Momwell%20US.svg',
      link: 'https://momwell.com'
    },
    referrals: {
      enabled: false,
      referrerAmount: 50,
      refereeAmount: 30,
      referralURI: 'https://momwell.portals.care/auth/signup',
      referralFAQ: 'https://www.momwell.com/referral-rewards/'
    },
    privacyPolicyUrl: 'https://www.momwell.com/privacy-policy',
    termsOfUseUrl: 'https://www.momwell.com/terms-of-use',
    stripePublicKey:
      'pk_live_51MPuEdLNFzW3YP872VyXIKFQq012FfHENs70SlRKM4bQ5XMCqdGmHsY8VThr4mlQkKlcaebjKEGv8t5FfOSapojv00hYSeSqQb',
    mainMenu: [
      {
        title: 'Appointments',
        link: PATIENT_WEB_PAGES_URLS.account.appointments,
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bf1b9079853dd9b9d9_appointments.svg',
        roles: ['*']
      },
      {
        title: 'Workshops & Courses',
        type: 'external',
        link: 'https://momwell_digital.portals.care/workshops',
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bfc2cbcbab683e36ae_courses.svg',
        roles: ['*']
      },
      {
        title: 'Forms',
        link: PATIENT_WEB_PAGES_URLS.account.questionnaires,
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/6474fa78506b37e70b798189_Form.svg',
        roles: ['*']
      },
      {
        title: 'Billing',
        link: 'billing',
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bf1599f3a16bdf2b6a_billing.svg',
        type: 'external',
        roles: ['*']
      }
    ],
    availableStates: {
      us: states
    }
  }
};
